
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["ICON_IMAGE",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"class":"ICON_IMAGE","xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 139.949 118.071"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 2495","transform":"translate(-348 -253)"}},[_c('rect',{staticClass:"stroke",attrs:{"data-name":"Rectangle 2445","width":"116","height":"82","rx":"2","transform":"translate(351 284)","fill":"none"}}),_c('path',{staticClass:"stroke",attrs:{"data-name":"Path 10278","d":"M369.476 272.166v-11.547a4.618 4.618 0 014.619-4.619H480.33a4.618 4.618 0 014.619 4.619v73.9a4.618 4.618 0 01-4.619 4.619h-2.309","fill":"none"}}),_c('circle',{staticClass:"stroke",attrs:{"data-name":"Ellipse 541","cx":"7.5","cy":"7.5","r":"7.5","transform":"translate(364 302)","fill":"none"}}),_c('path',{staticClass:"stroke",attrs:{"data-name":"Path 10279","d":"M397.417 336.539l-7.156-8.945-31.409 39.261","fill":"none"}}),_c('path',{staticClass:"stroke",attrs:{"data-name":"Path 10280","d":"M461.851 366.854l-36.949-46.189-36.951 46.189","fill":"none"}})])])
          )
        }
      }
    